
export default (store) => ({
  path: 'question/:sequence',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Question = require('./containers/QuestionContainer').default

      /*  Return getComponent   */
      cb(null, Question)

    /* Webpack named bundle   */
    }, 'Question')
  }
})



/** WEBPACK FOOTER **
 ** ./src/routes/Auth/routes/Discovery/routes/DecisionTool/routes/Question/index.js
 **/